<div class="home-page">

  <div class="background-glow"></div>

  <app-header></app-header>

  <section class="hero-section">

    <div class="hero-left">

      <span class="hero-badge">
        Desenvolvimento focado em performance e crescimento
      </span>

      <h1>
        Web, mobile e softwares 
        <span>
          para diferentes necessidades.
        </span>        
      </h1>

      <p>
        Soluções digitais, consultoria em arquitetura de software
        e integração de IA para projetos que precisam crescer com segurança.
      </p>

    </div>

    <div class="hero-right">

      <div class="floating-image-wrapper">

  <img
    src="images/logo_transp.png"
    alt="Tecnologia"
    class="floating-image"
  >

</div>


    </div>

  </section>


  <section class="services-highlight">

    <div class="services-copy">

      <span class="section-tag">CONSULTORIA E INTELIGÊNCIA ARTIFICIAL</span>

      <h2>
        Arquitetura bem definida.
        <span>IA integrada com propósito.</span>
      </h2>

      <p>
        Ajudamos equipes a diagnosticar sistemas, definir uma estratégia de evolução
        arquitetural e integrar recursos de IA aos processos e aplicações do negócio.
      </p>

    </div>

    <div class="services-list">

      <div>
        <strong>Consultoria em arquitetura de software</strong>
        <span>DDD, arquitetura hexagonal, modernização e governança técnica.</span>
      </div>

      <div>
        <strong>Integração de IA em projetos</strong>
        <span>Soluções conectadas aos seus dados, contexto e objetivos de negócio.</span>
      </div>

      <a href="mailto:smsmurilo@gmail.com?subject=Consultoria%20em%20Arquitetura%20e%20IA" class="primary-button">
        Falar com a SMS Murilo
      </a>

    </div>

  </section>

  <footer class="footer">

    <div class="footer-left">

      <img
        src="images/logo_transp.png"
        alt="Logo"
      >

      <div>

        <span>
          PLATAFORMA MANAGER
        </span>

      </div>

    </div>

    <div class="footer-right">

      <span>
        © 2026 SMS Softwares Inteligentes
      </span>

    </div>

  </footer>

</div>
